<template>
  <div
    class='companies__list'
  >
    <CompanyCard
      class='companies__job'
      v-for='result in results'
      :key="result.id"
      :company='result'
      mini
    />
  </div>
</template>

<script>
import CompanyCard from "../components/company-card";

import elasticSearch from "../lib/elastic-search";

export default {
  components: {
    CompanyCard,
  },

  data() {
    return {
      index: "companies",
      response: null,
    };
  },

  created() {
    const promise = this.fetchResults();
    promise.then(response => {
      this.isLoading = false;
      this.response = response;
    });
  },


  computed: {
    results() {
      if (this.response) {
        return this.response.hits.hits.map(el => {
          return {
            ...el._source
          };
        });
      } else return [];
    },

    query() {
      return {
        sort: [
          { featured_at: "desc" },
        ],
        query: {
          bool: {
            must: [
              { match: { application_status: "published" } },
              { match: { featured: "true" } },
            ],
            should: [
              { range: { project_count: { "gt": 0 }} },
              { match: { is_hiring: true } },
            ]
          }
        }
      };
    }
  },

  methods: {
    fetchResults() {
      this.isLoading = true;

      const promise = elasticSearch({
        index: 'companies',
        size: 6,
        body: this.query
      });

      return promise;
    },
  }
};
</script>

<style lang="scss" scoped>
.companies__list {
  margin: 48px 0 48px;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  display: grid;
  grid-gap: 2rem;
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/featured-companies.vue?9dd861d6